import {
  CONTENT_TYPE,
  videoPlayerIcon,
  WebIcon,
  standardMeetingRoom,
  meetingOverviewFull,
  meetingOverviewMessage,
  meetingOverviewportrait,
} from 'constants/index';
import { EventTemplateType } from 'enums';
import React from 'react';
import { iContentData } from 'types';
import styles from './contentPreview.module.scss';

interface iProps {
  className?: string;
  data: iContentData;
}

function ContentPreview(props: iProps): JSX.Element {
  const { className, data } = props;

  const TemplateImage =
    (data.templateData?.templateType === EventTemplateType.meetingRoom &&
      standardMeetingRoom) ||
    (data.templateData?.templateType ===
      EventTemplateType.meetingOverviewFull &&
      meetingOverviewFull) ||
    (data.templateData?.templateType ===
      EventTemplateType.meetingOverviewMessage &&
      meetingOverviewMessage) ||
    (data.templateData?.templateType ===
      EventTemplateType.meetingOverviewPotrait &&
      meetingOverviewportrait) ||
    '';

  return (
    <div className={`${styles.previewWrapper} ${className}`}>
      {data.contentType === CONTENT_TYPE.Video && (
        <video src={data.url} preload="none" controls>
          <source src={data.url} type="video/mp4" />
          <source src={data.url} type="video/WebM" />
          <source src={data.url} type="video/quicktime" />
          <track src="captions_en.vtt" kind="captions" />
        </video>
      )}
      {data.contentType === CONTENT_TYPE.Image && <img src={data.url} alt="" />}
      {data.contentType === CONTENT_TYPE.Website && (
        <img src={WebIcon} alt="" loading="lazy" />
      )}
      {data.contentType === CONTENT_TYPE.Video && (
        <img className={styles.videoPlayerIcon} src={videoPlayerIcon} alt="" />
      )}
      {data.contentType === CONTENT_TYPE.Template && (
        <img src={TemplateImage || ''} alt="" />
      )}
    </div>
  );
}

ContentPreview.defaultProps = {
  className: '',
};

export default ContentPreview;
